import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchOwnPortalSummary } from '@/api/portalSummary/portalSummaryApi';
import type { PortalSummary } from '@/api/portalSummary/portalSummaryApi.types';
import { OWN_PORTAL_SUMMARY_QUERY_KEY } from '@/constants/queryKeys';

const PORTAL_SUMMARY_STALE_TIME_MILLISECONDS = 30000;

export function usePortalSummaryQuery(): UseQueryResult<PortalSummary, Error> {
  return useQuery({
    queryKey: OWN_PORTAL_SUMMARY_QUERY_KEY,
    queryFn: fetchOwnPortalSummary,
    staleTime: PORTAL_SUMMARY_STALE_TIME_MILLISECONDS,
    refetchOnWindowFocus: true,
  });
}
